import http, { api } from '@/utils/http'
import Api from '@/conf/Api';
import notify from '@/utils/notify'

export const SERVICES_TYPE_LIST = ({ commit }, data) => api(Api.client.servicestype, data, commit)
export const DIARY_LIST = ({ commit }, data) => api(Api.client.diary, data, commit)

export const CREATE_JOB_ALOCACAO = ({ commit }, data) => api(Api.client.job.alocacao, data, commit)
export const CREATE_JOB_AVULSO = ({ commit }, data) => api(Api.client.job.avulso, data, commit)

export function LOAD_CLIENT_CLIENT({ commit }, data) {
  return http.post(Api.client.client_client, data)
    .then((res) => {
      if (res)
        commit('SET_CLIENT_CLIENT', res.data)
    }).catch((e) => {
      notify(commit, e)
    })
}

export function LOAD_TYPE_SERVICES({ commit }, data) {
  return http.get(Api.type_service, data)
    .then((res) => {
      if (res)
        commit('SET_TYPE_SERVICES', res.data)
    }).catch((e) => {
      notify(commit, e)
    })
}

export function CLIENT_COD_VERIFY({ commit }, { id_client, id_call }) {
  return http.get(Api.client.client_call.replace('?', id_client) + id_call).catch((e) => {
    notify(commit, e)
  })
}

export function CREATE_JOB({ commit }, job) {
  return http.post(Api.job, job).then((res) => {
    notify(commit, res)
    return res
  }).catch((e) => {
    notify(commit, e)
  })
}

